import * as yup from "yup";
import errorMessages, {
  COMMENTS_MAX_LENGTH
} from "protocol-setup/constants/errorMessages";

const { pendingSignOffForm } = errorMessages.openRave;

export const groupAdminSchema = yup.object().shape({
  releaseDateTime: yup
    .string()
    .required(pendingSignOffForm.groupAdmin.releaseDateTime),
  groupAdminSignOff: yup
    .boolean()
    .test(
      "is-true",
      pendingSignOffForm.groupAdmin.groupAdminSignOff,
      (value) => {
        return value === true;
      }
    )
    .required(pendingSignOffForm.groupAdmin.groupAdminSignOff),
  groupAdminComments: yup
    .string()
    .max(COMMENTS_MAX_LENGTH, pendingSignOffForm.groupAdmin.groupAdminComments)
    .optional()
});

export const openAdminSchema = yup.object().shape({
  openAdminSignOff: yup
    .boolean()
    .test(
      "is-true",
      pendingSignOffForm.openAdmin.openAdminSignOff,
      (value) => value === true
    )
    .required(pendingSignOffForm.openAdmin.openAdminSignOff),
  openAdminComments: yup
    .string()
    .max(COMMENTS_MAX_LENGTH, pendingSignOffForm.openAdmin.openAdminComments)
    .optional()
});

export const irocAdminSchema = yup.object().shape({
  irocAdminSignOff: yup
    .boolean()
    .test(
      "is-true",
      pendingSignOffForm.irocAdmin.irocAdminSignOff,
      (value) => value === true
    )
    .required(pendingSignOffForm.irocAdmin.irocAdminSignOff),
  irocAdminComments: yup
    .string()
    .max(COMMENTS_MAX_LENGTH, pendingSignOffForm.irocAdmin.irocAdminComments)
    .optional()
});

export const createDynamicSchema = (section) => {
  switch (section) {
    case "groupAdmin":
      return groupAdminSchema;
    case "openAdmin":
      return openAdminSchema;
    case "irocAdmin":
      return irocAdminSchema;
    default:
      return yup.object().shape({});
  }
};
